<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-29 09:23:42
 * @LastEditors: mrh
 * @LastEditTime: 2021-03-09 18:04:31
--> 
<template>
  <div class="goodsMsg">
    <van-tabs
      v-model="active"
      scrollspy
      offset-top="44"
      @scroll="scrolls()"
    >
      <van-tab title="商品">
        <div class="message">
          <van-swipe
            @change="onChange"
            :autoplay="3000"
          >
            <van-swipe-item
              v-for="(item,index) in picRotate"
              :key="index"
            >
              <img v-lazy="imgPrex+item" />
            </van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">{{ current + 1 }}/{{picRotate.length}}</div>
              <!-- <van-count-down
                v-show="objData.countDown>0 && isNotHot"
                :time="objData.countDown*1000"
                :format="formats"
              />
              <div v-show="objData.countDown == 0 && isNotHot" class="van-count-down">活动已结束</div>-->
            </template>
          </van-swipe>
          <!-- <div class="sharePositi" @click="share(goodData)">
            <i class="icon-fenxiang iconfont"></i>
            <span>分享</span>
          </div> -->
          <div
            class="countdown"
            v-if="!isPlain"
          >
            <img
              src="../../assets/img/detail_pic_huodong.png"
              alt
            />
            <div class="ps">
              <span>￥{{goodData.price}}</span>
              <span>￥{{goodData.guidePrice}}</span>
            </div>
            <!-- <van-count-down
              v-show="objData.countDown>0 && isNotHot"
              :time="objData.countDown*1000"
              :format="formats"
            /> -->
            <van-count-down
              :time="objData.countDown*1000"
              v-show="objData.countDown>0 && isNotHot"
            >
              <template #default="timeData">
                <p>{{objData.isStart == 0 ? "距开始" : "距结束"}}{{timeData.days}}天</p>
                <span class="block">{{ timeData.hours | timer }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.minutes | timer }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.seconds | timer }}</span>
              </template>
            </van-count-down>
            <div
              v-show="objData.countDown == 0 && isNotHot"
              class="van-count-down"
            >活动已结束</div>
          </div>
          <div class="texts">
            <span>{{goodData.name}}</span>
            <!-- <p>
              <span>佣金：¥{{goodData.shareMoney}}</span>
            </p>-->
            <span v-show="objData.hasOwnProperty('sharePromotionContent')">{{objData.sharePromotionContent}}</span>
          </div>
          <div class="tags">
            <span>{{goodData.factoryDeliverGoodsTime}}</span>
            <span v-show="goodData.shareMoney>0">分享赚￥{{goodData.shareMoney}}</span>
            <span v-show="goodData.communityShopMoney>0">佣金￥{{goodData.communityShopMoney}}</span>
            <!-- <van-tag color="#208FFF" round plain>{{goodData.factoryDeliverGoodsTime}}</van-tag>
            <van-tag
              color="#FF6F1C"
              plain
              round
              v-show="goodData.shareMoney>0"
            >分享赚￥{{goodData.shareMoney}}</van-tag>
            <van-tag
              color="#FF1310"
              plain
              round
              v-show="goodData.communityShopMoney>0"
            >佣金￥{{goodData.communityShopMoney}}</van-tag> -->
            <!-- <i class="icon-fenxiang1 iconfont" @click="share(goodData)"></i> -->
          </div>
          <div
            class="counts"
            v-if="!isPlain"
          >
            <span
              :class="{nums:objData.minNum - objData.hadBoughtNum > 0,finishs:objData.minNum - objData.hadBoughtNum == 0}"
              v-if="isPd"
            > {{objData.minNum - objData.hadBoughtNum}} </span>
            <span
              v-else
              class="finishs"
            > {{objData.saleNum}} </span>
          </div>
          <div
            v-if="isPlain"
            class="isPlain"
          >
            <span>￥{{goodData.price}}</span>
            <span>￥{{goodData.guidePrice}}</span>
          </div>
          <!-- <div class="prices">
            <div>
              
              <div class="numbers" v-show="!isPd && objData.rNum > 0 && objData.isStart == 0">
                <img src="../../assets/img/yy2.png" alt />
                <span>{{objData.rNum}}</span>
              </div>
            </div>

            <span
              v-if="goodData.collageOrder.minNum - goodData.collageOrder.hadBoughtNum > 0"
              class="nums"
            >{{goodData.collageOrder.minNum - goodData.collageOrder.hadBoughtNum}}份</span>
            <span v-else>{{text}}</span>
          </div>-->
          <div class="place">
            <span>产地：{{goodData.place}}</span>
            <span>邮费:免费配送</span>
            <!-- <span>{{goodData.factoryDeliverGoodsTime}}</span> -->
          </div>
          <div class="names">
            <i class="iconfont icon-cart_list_icon_store"></i>
            <span>{{goodData.sellerName}}</span>
          </div>
        </div>
      </van-tab>
      <van-tab
        title="推广文案"
        class="videoTab description"
        v-if="goodData.description"
      >
        <p>推广文案<span>[复制文案可以直接粘贴发送至社区群哦]</span></p>
        <div
          id="copy-txt"
          class="descriptionData"
          v-html="goodData.description"
        ></div>
        <div class="btn_group">
          <van-button
            color="#208FFF"
            @click.stop="copyTXT"
            class="copy"
          >复制推广文案</van-button>
        </div>
      </van-tab>
      <van-tab
        title="视频"
        class="videoTab vtab"
        v-if="videoData.length>0"
      >
        <p>视频</p>
        <!-- <div></div> -->
        <van-swipe
          indicator-color="#FF1310"
          show-indicators
        >
          <van-swipe-item
            v-for="(op,oidx) in videoData"
            :key="oidx"
            class="videos"
          >
            <img
              :src="op.coverUrl"
              alt
              class="videoImg"
              @click="playUrl(op.vodVideoId)"
            />
            <img
              src="../../assets/img/play.png"
              alt
              class="play"
              @click="playUrl(op.vodVideoId)"
            />
          </van-swipe-item>
        </van-swipe>
      </van-tab>
      <van-tab
        title="详情"
        class="videoTab"
      >
        <p>详情</p>
        <div
          v-for="(op,oidx) in detailsData"
          :key="oidx"
          class="detailsData"
        >
          <img
            :src="imgPrex+op"
            alt
          />
        </div>
      </van-tab>
    </van-tabs>
    <van-button
      round
      block
      type="info"
      class="btns"
      color="linear-gradient(to right, #FB6A4A, #FF0808)"
      @click="share(goodData)"
    >{{goodData.shareMoney>0?`分享赚¥${goodData.shareMoney}`:`分享`}}</van-button>

    <!-- 视频播放组件 -->
    <play-videos
      :show-video="showVideo"
      :videosrc="videosrc"
      @showVideo="getBoolearm($event)"
    />

    <!-- 分享组件 -->
    <share-popup
      :good-obj="shareObj"
      :show-popup="showPopup"
      @hidePopup="showPopups"
    />
  </div>
</template>
<script>
import { goodDetail, playUrl } from "@/api/join";
import sharePopup from "@/components/share/share";
export default {
  components: {
    sharePopup
  },
  data() {
    return {
      active: 0,
      //   list: [
      //     { title: "商品", list: [] },
      //     { title: "视频", list: [] },
      //     { title: "详情", list: [] }
      //   ],
      goodData: {}, //商品公共部分存储对象
      objData: {}, //爆款/拼单存储对象
      videoData: [],
      showVideo: false, //是否显示视频播放弹窗
      videosrc: "", //视频地址
      detailsData: [],
      current: 0,
      formats: "",
      isNotHot: true,
      picRotate: [], //轮播图
      shareObj: {}, //分享对象
      showPopup: false, //是否弹出分享组件
      isPd: false, //是否是拼单
      isPlain: false, //是否是普通商品
    };
  },
  filters: {
    timer(val) {
      if (val < 10) {
        val = "0" + val;
      }
      return val;
    }
  },
  mounted() {
    this.goodDetail();
  },
  methods: {
    goodDetail() {
      let obj = {
        communityShopId: this.$store.getters.communityShopId, //社区店长id
        sellerProductGoodsId: this.$route.query.sellerProductGoodsId //sellerProductGoodsId
      };
      goodDetail(obj).then(res => {
        // 字符串转数组再拼接
        let pic = [
          ...res.content.picRecommendation.split(","),
          ...res.content.picDes.split(",")
        ];
        pic = pic.filter(el => {
          return el.length > 0;
        });
        this.picRotate = res.content.picRotate.split(",");
        this.detailsData = pic;
        this.videoData = res.content.videoList;
        // console.log(this.$route.query.index);
        // let that = this
        this.goodData = res.content;
        let len = Object.keys(res.content.fastSelling).length;
        // 是否是普通商品
        this.isPlain =
          Object.keys(res.content.fastSelling).length == 0 &&
          Object.keys(res.content.collageOrder).length == 0;
        // len == 0？该商品事拼单商品：该商品是爆款商品
        this.objData =
          len == 0
            ? Object.keys(res.content.collageOrder).length > 0
              ? res.content.collageOrder
              : res.content
            : res.content.fastSelling;
        // console.log(this.objData);
        if (Object.keys(this.objData).length == 0) {
          this.isNotHot = false;
          return;
        }
        this.goodData.price = this.objData.price;
        this.goodData.guidePrice = this.objData.guidePrice;
        this.goodData.shareMoney = this.objData.shareMoney;
        this.goodData.communityShopMoney = this.objData.communityShopMoney;
        // this.formats =
        //   len == 0
        //     ? `距结束:\nDD天HH小时mm分ss秒`
        //     : `距${this.objData.isStart == 1 ? "结束" : "开始"}:\nDD天HH:mm:ss`;
        this.isPd =
          Object.keys(res.content.collageOrder).length > 0 ? true : false;
        // console.log(this.objData);
        // switch (this.$route.query.index*1) {
        //   case 0:
        //     that.goodData = res.content.fastSelling;
        //     break;
        //   case 1:
        //     that.goodData = res.content.collageOrder;
        //     break;
        //   case 2:
        //     that.goodData = res.content;
        //     break;
        //   default:
        //     break;
        // }
      });
    },
    onChange(index) {
      this.current = index;
    },
    // 获取动态视频地址
    playUrl(id) {
      // console.log("2");
      let obj = {
        vodVideoId: id //点播服务中视频id，cfp_vod_video中的 vod_video_id
      };
      playUrl(obj).then(res => {
        this.showVideo = true;
        this.videosrc = res.content.playUrl;
      });
    },
    // 监听子组件方法更新布尔值
    getBoolearm(bol) {
      //       console.log(bol);
      this.showVideo = bol;
    },

    // 分享
    share(e) {
      // console.log(e);
      if (e.headpic) {
        e.imageUrl = e.headpic;
        e.shareType = "1";
        // delete e.headpic;
      } else {
        e.shareType = "0";
      }
      this.showPopup = true;
      this.shareObj = e;
    },

    // 监听子组件方法更新布尔值
    showPopups(bol) {
      // console.log(bol)
      this.showPopup = bol;
    },

    copyTXT() {
      window.getSelection().removeAllRanges(); // 移除选中的元素
      var copyDOM = document.querySelector("#copy-txt"); //指定的DOM元素
      var range = document.createRange(); // 创建容器
      range.selectNode(copyDOM); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      var successful = document.execCommand("copy"); // 执行 copy 操作
      try {
        var msg = successful ? "复制成功" : "复制失败";
        // console.log("Copy was " + msg);
        this.$toast(msg)
      } catch (err) {
        // console.log("unable to copy");
      }
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.goodsMsg {
  width: auto;
  padding: 10px 0 0;
  height: calc(100% - 54px);
  // height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f4f4f4;
  //   margin-top: 44px;
  /deep/.van-tabs__wrap {
    position: fixed !important;
    width: 100%;
    height: 50px;
    left: 0;
    top: 44px;
    z-index: 2;
    .van-tab {
      width: 90px;
      flex: none;
    }
    .van-tabs__line {
      background: #ff685d;
    }
    .van-tab--active {
      color: #1d1d1d;
      font-weight: bold;
    }
  }

  /deep/.van-tabs__content {
    width: 100%;
    height: 100%;
    margin-top: 40px;
    .message {
      .van-swipe {
        width: 100%;
        height: 375px;
        background: #fff;
        .custom-indicator {
          position: absolute;
          right: 15px;
          bottom: 10px;
          font-size: 14px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          width: 40px;
          height: 22px;
          border-radius: 25px;
          text-align: center;
          line-height: 22px;
        }
        .van-count-down {
          width: 100%;
          height: 32px;
          line-height: 32px;
          text-align: center;
          color: #ff452a;
          font-size: 12px;
          font-weight: bold;
          background: linear-gradient(
            90deg,
            rgba(255, 125, 91, 1) 0%,
            rgba(255, 54, 54, 1) 100%
          );
          position: absolute;
          bottom: 0;
        }
        img {
          width: auto;
          height: 100%;
        }
      }
    }
  }
  // .sharePositi {
  //   width: 68px;
  //   height: 36px;
  //   border-radius: 18px 0px 0px 18px;
  //   background: #FF6E0D;
  //   position: fixed;
  //   top: 50%;
  //   right: 0px;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   color: #fff;
  //   z-index: 999;
  //   i {
  //     font-size: 25px;
  //   }
  //   span {
  //     font-size: 16px;
  //   }
  // }
  .countdown {
    width: 100%;
    height: 60px;
    position: relative;
    img {
      width: 100%;
    }
    .van-count-down {
      position: absolute;
      right: 20px;
      top: 8px;
      white-space: pre-line;
      text-align: center;
      color: #ff452a;
      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
      .block {
        width: 19px;
        height: 22px;
        line-height: 22px;
        display: inline-block;
        font-size: 13px;
        font-weight: 800;
        color: #ffffff;
        background-color: #ff5051;
        border-radius: 5px;
      }
      .colon {
        font-size: 16px;
        margin: 0 2px;
        font-weight: bold;
      }
    }
    .ps {
      width: auto;
      height: 32px;
      position: absolute;
      left: 15px;
      top: 15px;
      display: flex;
      align-items: baseline;
      > span:first-child {
        color: #fff;
        font-size: 24px;
      }
      > span:nth-child(2) {
        color: #fff;
        font-size: 14px;
        text-decoration: line-through;
        padding-left: 6px;
      }
    }
  }
  .texts {
    width: auto;
    min-height: 23px;
    padding: 10px 15px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    background: #fff;
    > span {
      color: #333;
      font-size: 20px;
      word-break: break-all;
    }
    > span:last-child {
      color: #8d8d8d;
      font-size: 12px;
    }
    // > p {
    //   height: 30px;
    //   display: flex;
    //   align-items: center;
    //   > span {
    //     color: #ff1310;
    //     font-size: 18px;
    //     font-weight: bold;
    //     margin-right: auto;
    //   }
    //   img {
    //     width: 67px;
    //     height: 30px;
    //     padding: 0;
    //   }
    // }
  }
  .tags {
    display: flex;
    align-items: center;
    background: #ffffff;
    // i {
    //   margin-left: auto;
    //   color: #ff1310;
    //   font-size: 25px;
    //   margin-right: 15px;
    // }
    span {
      width: auto;
      margin-right: 5px;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
    }
    span:first-child {
      margin-left: 15px;
      color: #ff9a34;
    }
    span:nth-child(2) {
      position: relative;
      height: 21px;
      line-height: 21px;
      padding-left: 23px;
      padding-right: 5px;
      display: inline-block;
      color: #ff1310;
      background-color: #f8f8f8;
      border-radius: 15px;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        width: 25px;
        height: 25px;
        background-image: url(../../assets/img/share.png);
        background-size: 100%;
      }
    }
    span:last-child {
      font-weight: 800;
      color: #ff1310;
    }
  }
  // .prices {
  //   min-height: 30px;
  //   padding: 4px 15px 10px;
  //   display: flex;
  //   flex-flow: column;
  //   justify-content: space-between;
  //   background: #fff;
  //   > div {
  //     height: 32px;
  //     display: flex;
  //     align-items: center;
  //     > span:first-child {
  //       color: #ff1310;
  //       font-size: 24px;
  //       font-weight: bold;
  //     }
  //     // .isPd::before {
  //     //   content: "拼单价";
  //     //   color: #1d1d1d;
  //     //   font-size: 15px;
  //     //   font-weight: normal;
  //     // }
  //     > span:nth-child(2) {
  //       color: #8d8d8d;
  //       font-size: 12px;
  //       text-decoration: line-through;
  //       padding-left: 2px;
  //     }
  //     .numbers {
  //       width: auto;
  //       height: 20px;
  //       display: flex;
  //       align-items: center;
  //       background: #feede5;
  //       border-radius: 0px 2px 9px 0px;
  //       margin-left: 10px;
  //       img {
  //         height: 20px;
  //       }
  //       span:last-child {
  //         width: auto;
  //         padding: 0 2px;
  //         font-size: 10px;
  //         transform: scale(0.8);
  //         color: #ff1310;
  //       }
  //     }
  //   }
  //   > span {
  //     font-size: 15px;
  //   }
  //   .nums {
  //     color: #ff1310;
  //     font-weight: bold;
  //     padding-top: 5px;
  //   }
  //   .nums::before {
  //     content: "还差";
  //     color: #333;
  //     font-weight: normal;
  //   }
  //   .nums::after {
  //     content: "份拼单成功";
  //     color: #333;
  //     font-weight: normal;
  //   }
  // }
  .counts {
    width: 100%;
    background: #fff;
    padding: 20px 0 10px 15px;
    span {
      font-size: 15px;
      color: #dc0d0d;
      font-weight: bold;
      padding-top: 5px;
    }
    .nums::before {
      content: "还差";
      color: #8b8e97;
      font-weight: normal;
    }
    .nums::after {
      content: "份拼单成功";
      color: #8b8e97;
      font-weight: normal;
    }

    .finishs::before {
      content: "已售";
      color: #8b8e97;
      font-weight: normal;
    }
    .finishs::after {
      content: "份";
      color: #8b8e97;
      font-weight: normal;
    }
  }
  .isPlain {
    width: 100%;
    background: #fff;
    padding: 20px 0 10px 15px;
    span:first-child {
      color: #ff1310;
      font-size: 24px;
    }
    span:last-child {
      color: #8d8d8d;
      font-size: 12px;
      text-decoration: line-through;
    }
  }
  .place {
    height: 20px;
    padding: 15px 0 15px 15px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    background: #fff;
    margin-top: 10px;
    span {
      font-size: 15px;
      color: #3e3e3e;
      position: relative;
      margin-right: 21px;
    }
    span::after {
      content: " ";
      width: 1.04px;
      height: 10px;
      background: #8d8d8d;
      position: absolute;
      right: -10px;
      top: 6px;
    }
    > span:first-child {
      color: #1d1d1d;
    }
    span:last-child:after {
      content: " ";
      position: inherit;
    }
  }
  .names {
    height: 30px;
    padding: 10px;
    display: flex;
    align-items: center;
    background: #fff;
    margin-top: 10px;
    i {
      font-size: 30px;
    }
    span {
      font-size: 17px;
      color: #3e3e3e;
      font-weight: bold;
      padding-left: 5px;
    }
  }
  .videoTab {
    min-height: 220px;
    margin-top: 10px;
    background: #fff;
    > p {
      width: 100%;
      height: 50px;
      line-height: 50px;
      color: #3e3e3e;
      font-size: 19px;
      font-weight: bold;
      padding: 0 15px;
    }
    .videos {
      width: 345px !important;
      height: 150px;
      position: relative;
      margin-right: 10px;
      .play {
        width: 61px;
        height: 61px;
        position: absolute;
        left: 0;
        right: 0;
        top: 40px;
        margin: 0 auto;
      }
      .videoImg {
        width: 345px;
        height: 150px;
      }
    }
  }
  .vtab {
    padding-left: 15px;
    > p {
      padding-left: 0;
    }
  }
  .description {
    min-height: inherit;
    p {
      span {
        margin-left: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }
    }
    .descriptionData {
      margin: 0 15px;
      padding: 15px;
      font-size: 13px;
      white-space: pre-line;
      background-color: #f8f8f8;
      &::selection {
        background-color: #f8f8f8;
      }
      &::-moz-selection {
        background-color: #f8f8f8;
      }
      &::-webkit-selection {
        background-color: #f8f8f8;
      }
    }
    .btn_group {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      .copy {
        width: 99px;
        height: 26px;
        padding: 0;
        font-size: 14px;
        border: 1.5px solid rgba(255, 81, 78, 1);
        border-radius: 25px;
      }
    }
  }
  .detailsData {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
  .detailsData:last-child {
    padding-bottom: 60px;
  }
  .btns {
    width: 355px;
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    .van-button__text {
      font-size: 19px;
    }
  }
}
</style>
